<template>
    <div class="unsubscribe">
        <div class="header">
            <div class="content" style="display: flex;justify-content: space-between;">
                <div style="font-weight: 600;font-size: 26px;">MILKYWAY</div>
                <div style="display: flex;align-items: center;column-gap: 16px;">
                    <Language />
                    <el-button type="primary" size="mini" @click="orderDetail()">{{ $t('DomesticTransportation.orderView') }}</el-button>
                </div>
            </div>
        </div>
        <div class="list-container">
            <div class="title">{{ $t('DomesticTransportation.unsubscribeCenter') }}</div>
            <div style="margin-top: 8px;">
                <!-- <span style="color:#53a2b6;margin-right: 12px;">UNSUBSCRIBE CENTER</span> -->
                <span style="color:gray">{{ $t('DomesticTransportation.subjectNotice') }}</span>
            </div>
            <div class="list-item">
                <div>{{ $t('DomesticTransportation.yourEmail') }}{{ email }}</div>
                <div style="width: 100%;height: 0.5px;background-color:#ccc;margin-top: 8px;"></div>
                <el-checkbox-group v-model="checkedCities">
                    <el-checkbox v-for="(subscript,index) in subScriptionList" :key="index" :label="subscript.UserSubscriptionID">
                        <div style="display: flex;justify-content: space-between;align-items: center;width: 660px;">
                            <div style="display: flex;justify-content: flex-start;align-items: center;flex:1;overflow: hidden;">
                                <div>{{ subscript.TopicName }}：</div>
                                <el-tooltip
                                :content="subscript.Remark"
                                placement="top"
                                :disabled="!isShowTooltip"
                                >
                                    <div style="font-size: 12px;color:#999;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;" @mouseenter="textOverflowing($event)">{{ subscript.Remark }}</div>
                                </el-tooltip>
                            </div>
                            <div style="width:100px;text-align: right;font-size: 12px;color:#999;">{{ changeLang(subscript.TopicType) }}</div>
                        </div>
                    </el-checkbox>
                </el-checkbox-group>
                <div style="position: absolute;bottom: 16px;left: 16px;right: 16px;">
                    <div style="width: 100%;height: 0.5px;background-color:#ccc;margin-bottom: 8px;"></div>
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                        <div style="color:#53a2b6">{{ $t('DomesticTransportation.unSubsribeTips') }}</div>
                        <el-button type="primary" size="mini" @click="submit()">{{ $t('DomesticTransportation.unSubsribeSubmit') }}</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-copyright">
            <div class="content">
                <div>
                    <span >
                        <img src="https://www.mwclg.com/_nuxt/img/national_emblem.9776b59.png" alt="" class="inline-block" style="width: 12px; margin-top: -2px" />
                        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502008520" style="color: #96aeb5">
                            沪公网安备 31011502008520号
                        </a>
                    </span>
                    <span class="inline-block" style="margin-left: 40px" >
                        <a href="https://beian.miit.gov.cn" target="_blank" style="color: #96aeb5">
                            沪ICP备11020557号-4
                        </a>
                    </span>
                </div>
                <div style="margin-top: 8px;">
                    Copyright © 2024 MILKYWAY INTELLIGENT SUPPLY CHAIN SERVICE GROUP CO., LTD. 密尔克卫智能供应链服务集团股份有限公司
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { GetSubscriptionList, UpdateSubscriptionStatus, CheckCancelSubscriptionUrl } from '@/api/tms'
import Language from '@/components/Language/index.vue'
import i18n from '@/i18n/i18n'
export default {
  components: {
      Language
  },
  data() {
    return {
      checkedCities: [],
      subScriptionList: [],
      userAccount: '',
      type: '',
      email: '',
      lang: 'zh',
      isShowTooltip: false, // 是否显示提示文字
    }
  },
  mounted() {
    this.lang = this.$ls.get('lang')
    this.type = this.$route.query.type || ''
    this.email = this.$route.query.email || ''
    this.userAccount = this.$route.query.userAccount || ''
    const sign = this.$route.query.sign || ''
    CheckCancelSubscriptionUrl({ sign, MailTo: this.email, UserAccount: this.userAccount }).then(res => {
      this.getData(this.type, this.email)
    })
  },
  methods: {
    getData(type, email) {
      GetSubscriptionList({
        MailTo: email,
        SubscriptionStatus: 'Subscription',
        SystemModule: type,
        UserAccount: this.userAccount,
        lang: this.lang
      }).then(res => {
        this.subScriptionList = res.data || []
      })
    },
    orderDetail() {
      this.$router.push({
        path: '/dashboard'
      })
    },
    submit() {
      if (!this.checkedCities.length) {
        this.$message.error(i18n.t('DomesticTransportation.notUnsubscribeNode'))
        return
      }
      const params = {
        UserSubscriptionID: this.checkedCities.join(),
        UserAccount: this.userAccount,
        SubscriptionStatus: 'CancelSubscription'
      }
      UpdateSubscriptionStatus(params).then(res => {
        this.$message.success(i18n.t('DomesticTransportation.unsubscribeSuccess'))
        this.checkedCities = []
        this.getData(this.type, this.email)
      })
    },
    changeLang(status){
        let value = ''
        if(this.lang === 'zh'){
            value = status
        }else {
            if(status === '订单状态'){
                value = 'Order Status'
            }else if(status === '定期报告'){
              value = 'Regular Reports'
            }
        }
        return value
    },
    textOverflowing(event) {
      const ev = event.target
      const evWeight = ev.scrollWidth // 文本的实际宽度   scrollWidth：对象的实际内容的宽度，不包边线宽度，会随对象中内容超过可视区后而变大。
      const contentWeight = ev.clientWidth // 文本的可视宽度 clientWidth：对象内容的可视区的宽度，不包滚动条等边线，会随对象显示大小的变化而改变。
      // const content_weight = this.$refs.tlp.$el.parentNode.clientWidth; // 文本容器宽度(父节点)
      if (evWeight > contentWeight) {
        // 实际宽度 > 可视宽度  文字溢出
        this.isShowTooltip = true
      } else {
        // 否则为不溢出
        this.isShowTooltip = false
      }
    }
  },
}
</script>
<style lang="less">
.unsubscribe {
    background-color: #F5F5F5;
    height: 100vh;
    .header{
        background-color: white;
        padding: 20px 0;
    }
    .page-copyright {
        width: 100%;
        color: #96aeb5;
        font-size: 12px;
        background-color: #173551;
        padding: 20px 0;
        position: fixed;
        bottom: 0;
    }
    .content {
        width:1200px;
        margin: auto;
    }
    .list-container {
        background-color: white;
        padding:16px 32px;
        width: 800px;
        margin: auto;
        margin-top: 12px;
        .title {
            font-weight: 600;
            font-size: 20px;
            color:#53a2b6
        }
        .list-item {
            margin-top: 16px;
            border: 2px solid #53a2b6;
            border-radius: 8px;
            height: 50vh;
            padding: 16px;
            position: relative;
        }
        .el-checkbox-group {
            height: 32vh;
            overflow-y: auto;
        }
        .el-checkbox {
            display: block;
        }
    }
}
</style>
